import Equal from 'customer-data-filters-ui/filterQueryFormat/operator/Equal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import NotKnown from 'customer-data-filters-ui/filterQueryFormat/operator/NotKnown';
import QuickFilterSelect from './QuickFilterSelect';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
import { View } from 'foundations-components/components/View';
import { useQuickFilterOpenState } from './hooks/useQuickFilterOpenState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BOOLEAN_OPTIONS = [{
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataFiltersUI.quickFiltersBar.boolean.trueValue"
  }),
  value: 'true'
}, {
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataFiltersUI.quickFiltersBar.boolean.falseValue"
  }),
  value: 'false'
}];
const getStateFromCondition = condition => {
  if (!condition) {
    return {
      boolean: undefined,
      isUnknownChecked: false
    };
  }
  if (condition instanceof NotKnown) {
    return {
      boolean: undefined,
      isUnknownChecked: true
    };
  }
  return {
    boolean: condition.value,
    isUnknownChecked: false
  };
};
const BooleanQuickFilter = ({
  buttonProperties,
  condition,
  disableTruncation,
  isFirst,
  property,
  onValueChange
}) => {
  const {
    isOpen,
    onToggleOpen
  } = useQuickFilterOpenState(property.name);
  const {
    boolean,
    isUnknownChecked
  } = getStateFromCondition(condition);
  const onBooleanChange = evt => {
    onValueChange(Equal.of(property, evt.target.value === 'true'));
    onToggleOpen();
  };
  const onCheckboxChange = evt => {
    if (evt.target.checked) {
      onValueChange(NotKnown.of(property));
    } else {
      onValueChange();
    }
    onToggleOpen();
  };
  const isActive = boolean !== undefined || isUnknownChecked;
  return /*#__PURE__*/_jsx(QuickFilterSelect, {
    property: property,
    buttonProperties: buttonProperties,
    buttonText: property.displayName,
    condition: condition,
    disableTruncation: disableTruncation,
    isActive: isActive,
    isFirst: isFirst,
    isOpen: isOpen,
    popoverContent: /*#__PURE__*/_jsxs(View, {
      margin: "500",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: "boolean-input",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFiltersBar.boolean.isEqual"
        })
      }), /*#__PURE__*/_jsx(ViewController, {
        "data-selenium-test": "BooleanQuickFilter-input",
        id: "boolean-input",
        onChange: onBooleanChange,
        options: BOOLEAN_OPTIONS,
        value: `${boolean}`
      }), /*#__PURE__*/_jsx(Checkbox, {
        "data-selenium-test": "BooleanQuickFilter-isUnknown",
        checked: isUnknownChecked,
        marginBlockStart: "200",
        onChange: onCheckboxChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFiltersBar.boolean.isUnknown"
        })
      })]
    }),
    onToggleOpen: onToggleOpen,
    onValueChange: onValueChange
  });
};
export default BooleanQuickFilter;